import React from 'react';

import {ToastContainer, ToastIcon, ToastSection, ToastText} from './styles';

export default ({toast}: {toast: object | any}) => (
  <ToastSection data-cy="toast">
    <ToastContainer theme={toast.theme}>
      <ToastText theme={toast.theme}>{toast.message}</ToastText>
      {toast.animated ? <ToastIcon theme={toast.theme} onClick={() => toast.action()} /> : <></>}
    </ToastContainer>
  </ToastSection>
);
